module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Whispers of Joy and Murmurs of Love")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#introduction"
    }
  }, [_vm._v("Introduction")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-one-the-miscarriage-at-the-marketplace"
    }
  }, [_vm._v("Chapter One: The Miscarriage at the Marketplace")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-two-preparation-toward-the-great-zado-festival"
    }
  }, [_vm._v("Chapter Two: Preparation Toward the Great Zado Festival")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-three-the-zado-festival-and-the-sinless-girls",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three: The Zado Festival and the Sinless Girls")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-four-fallouts-from-the-eventful-zado-festival",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four: Fallouts from the Eventful Zado Festival")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-five-two-beauty-goddesses-at-cross-purposes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five: Two Beauty Goddesses at Cross-Purposes")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-six-the-visit-of-the-mystery-girl",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: The Visit of the Mystery Girl")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-seven-the-invitation-of-the-zale-family-to-the-kings-palace",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: The Invitation of the Zale Family to the King’s Palace")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-eight-voberian-emperor-in-search-of-regional-peace",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: Voberian Emperor in Search of Regional Peace")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-nine-the-ground-breaking-summit-of-heads-of-state",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: The Ground-Breaking Summit of Heads of State")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-ten-the-new-look-sunrise-hemisphere",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten: The New-Look Sunrise Hemisphere")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-eleven-the-wedding-of-the-century",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven: The Wedding of the Century")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246b895e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0